import React, { useRef, useState, useCallback, useEffect } from "react";

import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Helmet } from "react-helmet";

import "./TrackPage.less";

import TrackContainer from "~/Containers/TrackContainer";
import TrackGenre from "~/Components/Elements/TrackGenre";
import ChimneyName from "~/Components/Elements/ChimneyName";
import TrackRecentContainer from "~/Containers/TrackRecentContainer";
import TrackBox from "~/Components/Elements/TrackBox";
import MediaProvider from "~/Components/library/MediaProvider";
import Motw from "~/Components/Features/Motw";
import Store from "~/Components/Features/Store";

import TrackHeader from "./TrackHeader";
import TrackDetails from "./TrackDetails";
import TrackReruleDetails from "./TrackReruleDetails";
import TrackFooter from "./TrackFooter";
// import TrackNavFooter from "./TrackNavFooter";
import CommentsList from "~/Components/Elements/CommentsList";
import Kba from "~/Components/Elements/Kba";
import RelatedTracks from "~/Components/SideNav/RelatedTracks";
import RelatedPlaylists from "~/Components/SideNav/RelatedPlaylists";
import { CdAndLpButton } from "~/Components/CdAndLp";
import Radio from "~/Components/Features/Radio";
import { getNumberOfTrackReplies } from "~/api/getTrack";
import axios from "react-axios";
import Store010 from "~/Components/Features/Store010";
import ShufflePromo from "~/Components/Features/ShufflePromo";
import Interviews from "~/Components/Features/Interviews";
import AdditionalFileUnder from "~/Components/Elements/AdditionalFileUnder";
import { AdditionalGenresProvider } from "~/Context/AdditionalGenresContext";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import ArtistBanner from "../Artist/ArtistBanner";
import { useTrackData } from "~/utils/useTrackData";


const TrackPage = ({ match }) => {
  const { track, loading: loadingTrack } = useTrackData(match.params.trackId);
  const [loadingReplyCounter, setLoadingReplyCounter] = useState(true);
  const [replyCount, setReplyCount] = useState(0);

  const load = async () => {
    const { data = [] } = await getNumberOfTrackReplies(axios, match.params.trackId);
    if (data.length !== 0) {
      const count = parseInt(data[0], 10)
      setReplyCount(count);
    }
    else {
      if (replyCount !== 0) setReplyCount(0);
    }
    setLoadingReplyCounter(false);
  };
  useEffect(() => {
    load();
  }, [match.params.trackId]);

  const showRightNavLevel1 = replyCount > 0;
  const showRightNavLevel2 = replyCount > 1;
  const showRightNavLevel3 = replyCount > 3;
  const showRightNavLevel4 = replyCount > 5;

  return (
    <MediaProvider>
      <div className="track-page-component page-layout-topic">
        <TrackContainer
          trackId={match.params.trackId}
          render={({ track, loading, failure }) => (
            <div style={{ marginBottom: "10px" }}>

              <Row>
                {((loading || loadingReplyCounter) && (
                  <Col xs={12} sm={{ span: 8, offset: 2 }} className="track-topic-box">
                    <SkeletonTheme color="#fff" highlightColor="#f3f3f3">
                      <Skeleton count={10} />
                    </SkeletonTheme>
                  </Col>
                )) || (
                    <React.Fragment>
                      <React.Fragment>
                        {(failure && (
                          <center>
                            Sadly this track was not found... but it might be here somewhere. Try the{" "}
                            <Link to={`/search`}>search option</Link>. Tons of great stuff here.
                          </center>
                        )) || (
                            <Col xs={12} className="track-topic-box">
                              <Helmet>
                                <title>
                                  "{track.title}" by {track.artist} | Dream Chimney
                                </title>
                                <meta property="og:title" content={`"${track.title}" by ${track.artist} | Dream Chimney`}></meta>
                                <link rel="canonical" href={`https://www.dreamchimney.com/tracks/${track.id}`} />
                              </Helmet>
                              <TrackHeader track={track} artistLink />
                              <Row>
                                <Col lg={9} xs={12}>
                                  <AdditionalGenresProvider trackId={track.id}>
                                    <div id="track-info-wrapper">
                                      <div className="posted-by">
                                        Track posted by <ChimneyName user={track.user} />
                                      </div>
                                      <TrackGenre track={track} label={true} />
                                    </div>
                                    <TrackDetails loading={loading} track={track} />
                                    <TrackReruleDetails loading={loading} track={track} />
                                    <TrackFooter track={track} />
                                    <AdditionalFileUnder trackId={track.id} />
                                    <CommentsList key={track.id} track={track} />
                                    <Kba margin="20px auto 60px auto" />
                                  </AdditionalGenresProvider>
                                </Col>
                                <Col lg={3} xs={12} className="rightSideNav">
                                  <div className="sideNavSection">
                                    <h4><FontAwesomeIcon icon={faShoppingCart} /> Buy This Album</h4>
                                    <CdAndLpButton artist={track.artist} album={track.album} />
                                  </div>
                                  <RelatedTracks trackId={match.params.trackId} />
                                  <RelatedPlaylists trackId={match.params.trackId} />

                                  <Motw />
                                  {showRightNavLevel1 && <><Store /></>}
                                  {showRightNavLevel2 && <><ShufflePromo /></>}
                                  {showRightNavLevel3 && <><Radio /></>}
                                  {showRightNavLevel4 && <><Store010 /></>}

                                </Col>
                              </Row>
                            </Col>
                          )}
                      </React.Fragment>
                    </React.Fragment>
                  )}
              </Row>
              {/* {!loading && !failure && <TrackNavFooter loading={loading} track={track} />} */}


            </div>
          )}
        />

        {!loadingTrack && (<ArtistBanner artistSlug={track.artist} />)}

        <TrackRecentContainer
          render={({ tracks, loading }) => {
            return (
              <Row className="related-tracks">
                <Col xs={12}>
                  <h2>
                    <FontAwesomeIcon icon="flag" className="flag" /> Recent Tracks
                  </h2>
                </Col>
                <Col xs={12}>
                  <Row>
                    {tracks &&
                      tracks.map((track) => {
                        return (
                          <Col xs={12} sm={6} md={4} key={track.id}>
                            <TrackBox track={track} />
                          </Col>
                        );
                      })}
                  </Row>
                </Col>
              </Row>
            );
          }}
        />
        <Kba />
      </div>
    </MediaProvider>
  );
};

export default TrackPage;
